import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { RolePermissions } from './role-permissions'
import { RolePermissionsSerializer } from './role-permissions.serializer'
import { Observable } from 'rxjs'

@Injectable()
export class RolePermissionsService extends ResourceService<RolePermissions> {
  public showModal: boolean = false
  public redirectToElement: boolean = false
  constructor(
    public http: HttpClient,
    rolePermissionsSerializer: RolePermissionsSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/role-permissions`,
      rolePermissionsSerializer
    )
  }

  public sendTestById(id: number, toEmail: string): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/role-permissions/${id}/test`,
      { toEmail }
    )
  }
}
